import axios from 'axios';
import { API_BASE_URL } from '../config/env';
import { storage } from './storage';
import { downloadBlob, getFilenameFromHeader } from './file';

export type SessaoTipo = 'usuario' | 'fornecedor';

const api = axios.create({
  baseURL: API_BASE_URL
});

export const storageKeys = {
  token: 'token_akzicao',
  usuario: 'usuario_akzicao',
  tenant: 'tenant_id',
  tipo: 'sessao_tipo_akzicao'
};

export const getToken = async () => await storage.getItem(storageKeys.token);

export const getSessaoTipo = async (): Promise<SessaoTipo> =>
  (await storage.getItem(storageKeys.tipo) as SessaoTipo) || 'usuario';

export const limparSessao = async () => {
  await storage.removeItem(storageKeys.token);
  await storage.removeItem(storageKeys.usuario);
  await storage.removeItem(storageKeys.tenant);
  await storage.removeItem(storageKeys.tipo);
};

api.interceptors.request.use(async (config) => {
  const token = await getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});


export const extrairMensagemErro = (erro: any, fallback: string) => {
  const data = erro?.response?.data;

  if (data && typeof data === 'object') {
    const mensagem = data.mensagem || data.message || fallback;
    const codigo = data.codigo_erro ? ` Código: ${data.codigo_erro}.` : '';
    const dataExpiracao = data.data_expiracao
      ? ` Expiração: ${new Date(data.data_expiracao).toLocaleDateString('pt-PT')}.`
      : '';
    const acoes = Array.isArray(data.acoes_disponiveis) && data.acoes_disponiveis.length > 0
      ? ` Ações disponíveis: ${data.acoes_disponiveis.map((acao: any) => acao.descricao).join(', ')}.`
      : '';

    return `${mensagem}${codigo}${dataExpiracao}${acoes}`;
  }

  if (erro?.response?.status === 500) {
    return 'O backend devolveu um erro interno. Confirme se a API e a base de dados estão ativas e tente novamente.';
  }

  if (erro?.code === 'ERR_NETWORK' || !erro?.response) {
    return 'Não foi possível contactar a API. Confirme se o serviço está ativo e acessível.';
  }

  return fallback;
};

export const baixarFicheiro = async (endpoint: string, fallbackNome = 'anexo') => {
  const resposta = await api.get(endpoint, { responseType: 'blob' });
  const nome = getFilenameFromHeader(resposta.headers?.['content-disposition'], fallbackNome);
  downloadBlob(resposta.data, nome);
};


api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('[API ERROR]', {
      message: error?.message,
      code: error?.code,
      url: error?.config?.url,
      baseURL: error?.config?.baseURL,
      status: error?.response?.status,
      data: error?.response?.data,
    });

    return Promise.reject(error);
  }
);

export default api;

